<template>
  <svg
    :aria-labelledby='iconName'
    :height='height'
    :viewBox='viewBox'
    :width='width'
    xmlns="http://www.w3.org/2000/svg"
  >
    <slot />
  </svg>
</template>

<script>
/**
 * @component WorkIconWrapper
 * @description SVG wrapper component for custom icons.
 * Renders an `<svg>` element with configurable dimensions and viewBox.
 *
 * @prop {String} [viewBox='0 0 24 24'] - SVG viewBox attribute.
 * @prop {String} [iconName=''] - Icon name (used as `aria-labelledby`).
 * @prop {Number|String} [width=24] - Width of the SVG element.
 * @prop {Number|String} [height=24] - Height of the SVG element.
 *
 * @slot default - SVG paths and elements of the icon.
 */
export default {
  name: 'WorkIconWrapper',
  props: {
    viewBox: { type: String, default: '0 0 24 24' },
    iconName: { type: String, default: '' },
    width: { type: [Number, String], default: 24 },
    height: { type: [Number, String], default: 24 },
  },
};
</script>
